export default (field, percentual, decimalPrecision = 4) => (item) => {
  const originalPrice = item.quoted && item.quoted.price
  const newPrice = (originalPrice * ((percentual / 100) + 1)).toFixed(decimalPrecision)
  // const newTotal = newPrice * item.itemInfo.quantity

  if (originalPrice) {
    const ret = {
      quote: item.itemId,
      [`${field}Price`]: newPrice
    }

    return ret
  }
  return false
}



// WEBPACK FOOTER //
// ./src/view/item-pricing/helpers/CalculatePercentualByField.js